module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminvideoayuda/adminvideoayuda.component.scss
// module id = ./src/app/adminvideoayuda/adminvideoayuda.component.scss
// module chunks = main